module.exports = __webpack_public_path__ + "static/media/TeleMeditar_Logo.89df9bec.png";